import { getTrialBalanceMapedElements } from 'api/trial-balance-api';
import { createAction } from 'redux-actions';

export const trialBalanceMapedElementsLoading = createAction(
  'TRIAL_BALANCE_MAPED_ELEMENTS_LOADING',
);
export const trialBalanceMapedElementsLoaded = createAction(
  'TRIAL_BALANCE_MAPED_ELEMENTS_LOADED',
);
export const trialBalanceMapedElementsError = createAction(
  'TRIAL_BALANCE_MAPED_ELEMENTS_ERROR',
);
export const clearTrialBalanceMapedElements = createAction(
  'TRIAL_BALANCE_CLEAR_MAPED_ELEMENTS',
);

export const setTBSourceElementClicked = createAction(
  'TRIAL_BALANCE_SET_SOURCE_ELEMENT_CLICKED',
);
export const removeTBSourceElementClicked = createAction(
  'TRIAL_BALANCE_REMOVE_SOURCE_ELEMENT_CLICKED',
);
export const setTBTargetElementClicked = createAction(
  'TRIAL_BALANCE_SET_TARGET_ELEMENT_CLICKED',
);
export const removeTBTargetElementClicked = createAction(
  'TRIAL_BALANCE_REMOVE_TARGET_ELEMENT_CLICKED',
);

export const resetMappedElements = createAction(
  'TRIAL_BALANCE_RESET_MAPPED_ELEMENTS',
);

export const fetchTrialBalanceMapedElements =
  ({ statementId, revisionId, clientId, withoutLoading = false }) =>
  async (dispatch) => {
    !withoutLoading && dispatch(trialBalanceMapedElementsLoading());
    try {
      const response = await getTrialBalanceMapedElements({
        statementId,
        revisionId,
        clientId,
      });
      dispatch(trialBalanceMapedElementsLoaded({ response }));
    } catch (error) {
      dispatch(trialBalanceMapedElementsError({ error }));
    }
  };
